import {  GET_DOCUMENT_CLASSIFICATION_DROP_DOWN_URL } from "../../api/commonRoutepath";
import request from "../../api/agent";




export const getDocumentsDropdown = (client) => onResponse => {
    try {

        request.get(GET_DOCUMENT_CLASSIFICATION_DROP_DOWN_URL + "?client=" + client)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });

    } catch (error) {

    }

};

